// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NO_BIND_TO } from '@shared/utils/Trading/OrderConstants';
import { DynProperty } from '../../DynProperty';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class BoundToEdit {
    constructor() {
        this.boundToOrderId = NO_BIND_TO;
        this.currentOrderId = NO_BIND_TO;
        this.bindToOrderIdArr = [];
    }
    getDynProperty() {
        const dp = new DynProperty();
        dp.type = DynProperty.COMBOBOX;
        dp.value = this.boundToOrderId;
        dp.localizationKey = 'screen.modifyOrder.bind_to';
        dp.objectVariants = [];
        dp.objectVariants.push({
            type: NewContextMenuItemType.Default,
            text: 'property.None',
            value: NO_BIND_TO
        });
        const orderIdArr = this.bindToOrderIdArr;
        for (let i = 0, len = orderIdArr.length; i < len; i++) {
            const orderId = orderIdArr[i];
            dp.objectVariants.push({
                type: NewContextMenuItemType.Default,
                value: orderId,
                text: orderId
            });
        }
        return dp;
    }
    update(updateData) {
        let parameterChanged = false;
        const dp = updateData.dp;
        if (dp) {
            parameterChanged = this.updateFromDynProperty(dp) || parameterChanged;
        }
        const newTradingDataDict = updateData.newTradingDataDict;
        if (!newTradingDataDict) {
            return parameterChanged;
        }
        const order = newTradingDataDict.order;
        if (!order) {
            return parameterChanged;
        }
        this.currentOrderId = order.OrderNumber;
        this.boundToOrderId = order.BoundTo;
        this.bindToOrderIdArr = order.DataCache.Trading.getBindToOrderIdArray(order);
        parameterChanged = true || parameterChanged;
        return parameterChanged;
    }
    updateFromDynProperty(dp) {
        let parameterChanged = false;
        const newVal = dp.value;
        if (newVal !== this.boundToOrderId) {
            this.boundToOrderId = newVal;
            parameterChanged = true || parameterChanged;
        }
        return parameterChanged;
    }
    getRawValue() {
        return this.boundToOrderId;
    }
}
